import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick", "onKeydown", "aria-label"]
const _hoisted_2 = { class: "menu-list-item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.isLogin)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "login-text",
          variant: "text",
          ripple: false,
          onClick: $setup.login
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("로그인")), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : ($setup.isLogin)
        ? (_openBlock(), _createBlock(_component_v_menu, {
            key: 1,
            modelValue: $setup.menu,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.menu) = $event)),
            location: "bottom end",
            transition: "none",
            "close-on-content-click": true
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                icon: "",
                class: "btn-user-name",
                "aria-label": `${$setup.$session.getUserInfo()?.NAME} ${_ctx.$t('프로필')}`,
                ripple: false
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.state.userInfo.NAME), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["aria-label"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: "menu-list",
                role: "menu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.btnList, (btn, index) => {
                    return _createElementVNode("div", {
                      key: btn.key,
                      ref_for: true,
                      ref: "btnRefs",
                      class: "menu-list-item",
                      onClick: ($event: any) => ($setup.onClickHandler(btn.key)),
                      onKeydown: ($event: any) => ($setup.onBtnItemKeydown($event, index, btn.key)),
                      tabindex: "1",
                      "aria-label": _ctx.$t(btn.label),
                      role: "menuitem",
                      "aria-roledescription": "button"
                    }, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(btn.label)), 1 /* TEXT */)
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
  ]))
}